import { Router } from "@angular/router";
import { Component, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { RequestInstanceDTO } from "src/app/parametrage/core/model/request-instance-dto";
import { UserService } from "src/app/shared/directives/user.service";
import { KeycloakService } from "src/app/core/services/auth/keycloak.service";
import { CorporateService } from "../../core/service/corporate.service";
import { DetenteurComponent } from "src/app/formulaire/modal/detenteur/detenteur.component";
import { FormulaireDTO } from "src/app/parametrage/core/model/formulaire-dto";
import { FormulaireService } from "src/app/parametrage/core/service/formulaire.service";
import { SuiviComponent } from "src/app/formulaire/modal/suivi/suivi.component";
import { RequestService } from "src/app/parametrage/core/service/request.service";
import { ReactiverDossierComponent } from "src/app/formulaire/modal/reactiver-dossier/reactiver-dossier.component";

@Component({
  selector: "app-abandonne",
  templateUrl: "./abandonne.component.html",
  styleUrls: ["./abandonne.component.scss"],
})
export class AbandonneComponent implements OnInit {
  isLoadingResults = true;

  MyPermissions: string[];

  private userPermission = {
    permissions: [],
  };

  dossiers: RequestInstanceDTO[];

  page: number = 1;
  totalElements: number = 0;
  filter: String = "";

  formulaire: FormulaireDTO;

  constructor(
    private _router: Router,
    private modalService: NgbModal,
    private userService: UserService,
    private _keycloakService: KeycloakService,
    private _corporateService: CorporateService,
    private _formulaireService: FormulaireService,
    private _requestService: RequestService
  ) {
    this.MyPermissions = _keycloakService.getAccessPermissions();
    this.userPermission.permissions = this.MyPermissions;
    this.userService.setUser(this.userPermission);
  }

  ngOnInit() {
    this.getAll(this.filter, 0, 5);
  }

  getAll(filter, page, size) {
    this.isLoadingResults = true;

    this._corporateService
      .findAllDossierAbandonne(filter, page, size)
      .subscribe(
        (data) => {
          this.isLoadingResults = false;
          this.dossiers = data.content;
          this.totalElements = data.totalElements;
        },
        (error) => {
          console.log(error);
          this.isLoadingResults = false;
        }
      );
  }

  loadPage(page: number): void {
    page = page - 1;
    this.getAll(this.filter, page, 5);
  }

  searchAndRefresh(): void {
    this.getAll(this.filter, 0, 5);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filter = filterValue;
    this.page = 0;
    this.getAll(this.filter, this.page, 5);
  }

  dossierInfo(requestId) {
    this._formulaireService.takeFormInfoRequest(requestId).subscribe(
      (data) => {
        this.formulaire = data;
        this._router.navigateByUrl(this.formulaire.url);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  userByRole(requestId) {
    const modalRef = this.modalService.open(DetenteurComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.requestId = requestId;

    modalRef.result.then(
      (data) => {},
      (reason) => {}
    );
  }

  suivi(requestId) {
    const modalRef = this.modalService.open(SuiviComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.requestId = requestId;

    modalRef.result.then(
      (data) => {
        // on close
      },
      (reason) => {}
    );
  }

  reactiver(requestId) {
    const modalRef = this.modalService.open(ReactiverDossierComponent, {
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.requestId = requestId;

    modalRef.result.then(
      (data) => {
        this.getAll(this.filter, 0, 5);
      },
      (reason) => {}
    );
  }

  deleteRequest(requestId) {
    this._requestService.delete(requestId).subscribe(
      (data) => {
        this.searchAndRefresh();
      },
      (error) => {
        console.log(error);
      }
    );
  }
}
